import { useCallback, useState } from "react";

const STORAGE_KEYS = {
  rules: "hr-promotion-rules-tour-completed",
  records: "hr-promotion-records-tour-completed",
  history: "hr-promotion-history-tour-completed",
  ruleCreate: "hr-promotion-rule-create-tour-completed",
  ruleEdit: "hr-promotion-rule-edit-tour-completed",
  recordCreate: "hr-promotion-record-create-tour-completed",
  recordDetail: "hr-promotion-record-detail-tour-completed",
  recordEdit: "hr-promotion-record-edit-tour-completed",
} as const;

export type PromotionTourPage = keyof typeof STORAGE_KEYS;

export function usePromotionTour(page: PromotionTourPage) {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const storageKey = STORAGE_KEYS[page];

  const hasCompletedTour = () => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(storageKey) === "true";
  };

  const startTour = useCallback(() => {
    setRun(true);
    setStepIndex(0);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const handleJoyrideCallback = useCallback(
    (data: { status?: string; type?: string; index?: number }) => {
      if (data.index !== undefined) setStepIndex(data.index);
      if (
        data.status === "finished" ||
        data.status === "skipped" ||
        data.type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour],
  );

  return {
    run,
    stepIndex,
    startTour,
    stopTour,
    hasCompletedTour: hasCompletedTour(),
    handleJoyrideCallback,
  };
}
